// src/components/Logs/LogRow.jsx
import React, { useState } from 'react';
import LogDetailDrawer from './LogDetailDrawer';

export default function LogRow({ log, compact = false }) {
  const [open, setOpen] = useState(false);

  const dotColor =
    log.level === 'ERROR' || log.level === 'CRITICAL' ? '#ef4444' :
    log.level === 'WARN'  || log.level === 'WARNING'  ? '#f59e0b' :
    log.level === 'INFO'  ? '#3b82f6' : '#475569';

  return (
    <>
      <div
        onClick={() => setOpen(true)}
        className="flex items-center gap-2 px-3 py-2 hover:bg-white/[0.05] cursor-pointer transition-colors"
        style={{ borderBottom: '1px solid rgba(255,255,255,.03)', minHeight: compact ? 36 : 42 }}
        title="Click to drill down"
      >
        <div className="w-1.5 h-1.5 rounded-full shrink-0" style={{ background: dotColor }} />
        <span className={`level-badge level-${log.level}`}>{log.level}</span>
        <span className={`source-badge source-${log.source}`}>{log.source}</span>
        <span className="mono text-xs shrink-0" style={{ color: 'var(--text-3)', minWidth: 72 }}>
          {new Date(log.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
        </span>
        <span className="text-xs flex-1 truncate" style={{ color: 'var(--text-2)' }}>{log.message}</span>
        {!compact && log.service && (
          <span className="text-xs shrink-0 mono" style={{ color: 'var(--text-3)' }}>
            {log.service.slice(0, 20)}
          </span>
        )}
        <span style={{ color: 'var(--text-3)', fontSize: 12, flexShrink: 0 }}>›</span>
      </div>

      {open && <LogDetailDrawer log={log} onClose={() => setOpen(false)} />}
    </>
  );
}
